import React from "react";
import Layout from "@/components/Layout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";

const Privacy = () => {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <Card className="max-w-4xl mx-auto">
          <CardHeader>
            <CardTitle className="text-3xl font-bold text-center">Privacy Policy</CardTitle>
          </CardHeader>
          <CardContent>
            <ScrollArea className="h-[calc(100vh-200px)] pr-4">
              <div className="space-y-6">
                <section>
                  <h2 className="text-xl font-semibold mb-4">1. Information We Collect</h2>
                  <div className="space-y-4 text-muted-foreground">
                    <h3 className="font-medium">1.1 Personal Information</h3>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>Email address and password for account creation</li>
                      <li>Name and profile information (optional)</li>
                      <li>Usage data and preferences</li>
                      <li>Device information and IP address</li>
                    </ul>

                    <h3 className="font-medium">1.2 Content Analysis Data</h3>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>Text content submitted for analysis</li>
                      <li>URLs of sources being verified</li>
                      
                     
                    </ul>
                  </div>
                </section>

                <section>
                  <h2 className="text-xl font-semibold mb-4">2. How We Use Your Information</h2>
                  <div className="space-y-4 text-muted-foreground">
                    <ul className="list-disc pl-6 space-y-2">
                      <li>To provide and maintain our service</li>
                      <li>To improve and personalize your experience</li>
                      <li>To communicate with you about service updates</li>
                      <li>To detect and prevent fraud or abuse</li>
                      <li>To comply with legal obligations</li>
                    </ul>
                  </div>
                </section>

                <section>
                  <h2 className="text-xl font-semibold mb-4">3. Data Security</h2>
                  <p className="text-muted-foreground">
                    We implement appropriate technical and organizational measures to protect your personal 
                    information against unauthorized access, alteration, disclosure, or destruction. This 
                    includes encryption, secure servers, and regular security assessments.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold mb-4">4. Data Retention</h2>
                  <p className="text-muted-foreground">
                    We retain your personal information only for as long as necessary to fulfill the 
                    purposes outlined in this Privacy Policy. You can request deletion of your account 
                    and associated data at any time.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold mb-4">5. Your Rights</h2>
                  <div className="space-y-4 text-muted-foreground">
                    <p>You have the right to:</p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>Access your personal information</li>
                      <li>Correct inaccurate data</li>
                      <li>Request deletion of your data</li>
                      
                    </ul>
                  </div>
                </section>

            

                <section>
                  <h2 className="text-xl font-semibold mb-4">7. Third-Party Services</h2>
                  <p className="text-muted-foreground">
                    We may use third-party services for analytics, authentication, and other functions. 
                    These services have their own privacy policies and may collect information as 
                    specified in their respective policies.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold mb-4">8. Children's Privacy</h2>
                  <p className="text-muted-foreground">
                    Our service is not intended for children under 13 years of age. We do not knowingly 
                    collect personal information from children under 13.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold mb-4">9. Changes to Privacy Policy</h2>
                  <p className="text-muted-foreground">
                    We may update this Privacy Policy from time to time. We will notify you of any 
                    changes by posting the new Privacy Policy on this page and updating the "Last 
                    updated" date.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold mb-4">10. Contact Us</h2>
                  <p className="text-muted-foreground">
                    If you have any questions about this Privacy Policy, please contact us at 
                   wobyebgraphlin90@gmail.com
                  </p>
                </section>

                <section className="mt-8">
                  <p className="text-sm text-muted-foreground">
                    Last updated: {new Date().toLocaleDateString()}
                  </p>
                </section>
              </div>
            </ScrollArea>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default Privacy; 